// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pg-1";
export var messageSideRight = "_pg-2";
export var orderLookupBubbleContainer = "_pg-0";
export var submitButton = "_pg-3";